import './RoomChatting.scoped.scss'
import PlainMessage from './PlainMessage';
import { useRecoilState } from 'recoil';
import participantsState from '../../../atoms/participants';
import userDetailsState from '../../../atoms/userDetails';
import messagesState from '../../../atoms/messages';
import { KeyboardEvent, useEffect, useRef, useState } from 'react';
import emitSendMessage from '../../../connector/emits/sendMessage';
import { getUser } from '../../../connector';
import { MessageType, SystemMessageType } from '../../../connector/type';
import emitCleanRoom from '../../../connector/emits/cleanRoom';
import myInfoState from '../../../atoms/myinfo';
import roomDetailState from '../../../atoms/roomDetail';
import SystemMessage from './SystemMessage';
import emitGiftBullet from '../../../connector/emits/giftBullet';
import Pick from './Pick';

function getScrolledPercent(element: HTMLElement) {
  if (element == null) {
    return 0;
  }
  const scrollRange = element.scrollHeight - element.offsetHeight;
  return Math.round((element.scrollTop / scrollRange) * 100);
}

function RoomChatting() {
  // Recoil
  const [roomDetail] = useRecoilState(roomDetailState);
  const [myInfo] = useRecoilState(myInfoState);
  const [participants] = useRecoilState(participantsState);
  const [userDetails] = useRecoilState(userDetailsState);
  const [messages] = useRecoilState(messagesState);

  // Local state
  const [hasFirstScrolled, setHasFirstScrolled] = useState(false);
  const [message, setMessage] = useState('');
  const [lastScrolledPercent, setLastScrolledPercent] = useState(0);
  const [isOpenedPick, setIsOpenedPick] = useState(false);
  const messagesReference = useRef<HTMLDivElement>(null);

  // Effect
  useEffect(() => {
    setTimeout(() => {
      if (messagesReference.current != null) {
        messagesReference.current.scrollTop = messagesReference.current.scrollHeight;
        setLastScrolledPercent(100);
      }
      messagesReference.current?.addEventListener('scroll', (event) => {
        if (messagesReference.current == null) {
          return;
        }
        setLastScrolledPercent(getScrolledPercent(messagesReference.current));
      });
    }, 500);
  }, []);

  useEffect(() => {
    if (messagesReference.current == null) {
      return;
    }
    if (!hasFirstScrolled && messages.messages.length > 0) {
      setHasFirstScrolled(true);
      messagesReference.current.scrollTop = messagesReference.current.scrollHeight;
      return;
    }
    if (lastScrolledPercent === 100) {
      messagesReference.current.scrollTop = messagesReference.current.scrollHeight;
    }
  }, [hasFirstScrolled, lastScrolledPercent, messages]);

  // Event
  const onKeyPressinput = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  // Handle
  const sendMessage = () => {
    if (message.length === 0) {
      return;
    }
    emitSendMessage(participants.roomId, {
      user: getUser(),
      messageType: MessageType.PLANE,
      contents: message,
    });
    setMessage('');
  }

  const cleanRoom = () => {
    emitCleanRoom();
  }

  const giftBullet = () => {
    const quantity = Number(window.prompt(`현재 보석 보유 개수: ${myInfo.bullet}\n방장에게 선물 할 보석의 개수를 입력해주세요 (숫자만 입력)`));
    if (!isNaN(quantity)) {
      if (quantity <= 0) {
        window.alert('선물할 보석의 개수를 정상적으로 입력해주세요.');
      } else if (quantity > myInfo.bullet) {
        window.alert('선물할 보석의 개수가 부족합니다.');
      } else {
        emitGiftBullet(quantity);
      }
    } else {
      window.alert('정확한 숫자를 입력해 주시기 바랍니다.');
    }
  }

  // Build messageComponents
  const messageComponents = messages.roomId === participants.roomId
    ? messages.messages.map((message, index) => {
      if (message.messageType === MessageType.SYSTEM) {
        return (
          <SystemMessage
            key={index}
            userId={message.user} 
            userDetail={userDetails.get(message.user)}
            contents={message.contents as { systemMessageType: SystemMessageType }}
          />
        );
      }
      return (
        <PlainMessage 
          key={index}
          userId={message.user} 
          userDetail={userDetails.get(message.user)}
          contents={message.contents as string}
        />
      );
    })
    : null;

  return (
    <div className='chatting'>
      <div 
        className="chatting-messages"
        ref={messagesReference}
      >
        {
          messageComponents
        }
      </div>
      <div className='chatting-buttons'>
        {
          roomDetail.owner === myInfo.id
            ? (
              <>
                <button onClick={cleanRoom}>방청소</button>
                <button
                  className="float-right"
                  onClick={() => setIsOpenedPick(!isOpenedPick)}
                >
                  { isOpenedPick ? '픽 닫기' : '픽 열기' }
                 </button>
              </>
            )
            : (
              <button onClick={giftBullet}>보석 선물하기</button>
            )
        }
{/*        <button onClick={() => {}}>추천하기</button>
        <button onClick={() => {}}>사운드 끄기</button>
        <button onClick={() => {}}>이모티콘</button>
        <button onClick={() => {}}>즐겨찾기</button>*/}
      </div>
      <div className="chatting-input">
        <input 
          type="text" 
          placeholder="내용 입력" 
          id="chat_input" 
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={onKeyPressinput} 
        />
        <button onClick={sendMessage}></button>
      </div>
      {
        isOpenedPick
        ? <Pick />
        : null
      }
    </div>
  );
}

export default RoomChatting;
